import React, { Fragment, useState } from "react";
import { isMobile } from "react-device-detect";
import { Dialog } from "@material-ui/core";
import AdTaskForm from "./AdTaskForm";
import { DownloadAdSampleFile, DownloadADTemplateFile } from "../apiService";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo } from "../../../../utils";
import CamoCTA from "../../../../shared_elements/components/cta/CamoCTA";
import { smbcInstance } from "../../../../shared_elements/components";
const AdSearchBar = ({ applyingFilter, filterOptions, tabIndex, pageLoader, props, searchData, fileUploadData, importFile, exportReportFn, headerTsn, headerCsn, currentRecordPerPage, uuid, slug, getResponseBack, basicDetails }) => {
    const [open, setOpen] = useState(false);
    const [formTitle, setFormTitle] = useState("");
    const [actionType, setActionType] = useState("");

    const addNewTask = () => {
        setOpen(true);
        setFormTitle("Airworthiness Directives (ADs)");
        setActionType("add");
    };

    const importFileFunc = (e) => {
        const files = e.target.files;
        const formData = new FormData();
        formData.append("file", files[0]);
        importFile(formData, props, true);
        e.target.value = null;
    };

    const filterParams = convertFilterObject(removeEmptyKey(applyingFilter), filterOptions);

    return (
        <Fragment>
            <div id="AmpSearchBar">
                <CamoCTA
                    searchPlaceholder={smbcInstance ? 'Search by AD Description' : 'Search ATA Chapter, AD Reference Number, AD Issuing Authority, AD Description'}
                    onSearch={(value) => searchData({ target: { value } })}
                    permissionCheck={!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
                    addLabel="ADD AD STATUS"
                    onAddFn={addNewTask}
                    onImportFn={importFileFunc}
                    exportMenu={{
                        exportReportFn: exportReportFn,
                        files: [
                            { title: 'PDF', extension: 'pdf', key: '' },
                            { title: 'EXCEL', extension: 'xlsx', key: '' },
                        ],
                    }}
                    downloadSampleMenu={{
                        exportReportFn: (file) => file.key === 'template'
                            ? DownloadADTemplateFile({ download: file.extension, ...filterParams }, pageLoader, props, basicDetails)
                            : DownloadAdSampleFile({ download: file.extension, ...filterParams }, pageLoader, props, basicDetails),
                        files: [
                            { title: 'DOWNLOAD SAMPLE', extension: 'xlsx', key: 'sample' },
                            { title: 'TEMPLATE', extension: 'xlsx', key: 'template' },
                        ],
                    }}
                />
                <Dialog open={open} style={{ height: isMobile && "650px" }}>
                    <AdTaskForm
                        formTitle={formTitle}
                        closeAddForm={() => setOpen(false)}
                        addForm={() => setOpen(true)}
                        props={props}
                        headerTsn={headerTsn}
                        headerCsn={headerCsn}
                        actionType={actionType}
                        fileUploadData={fileUploadData}
                        currentRecordPerPage={currentRecordPerPage}
                        uuid={uuid}
                        slug={slug}
                        basicDetails={basicDetails}
                        getResponseBack={() => getResponseBack()}
                    />
                </Dialog>
            </div>
        </Fragment>
    );
};

export default AdSearchBar;
